export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.recruits = payload

  return newState;
};
